import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalActions } from '../../../_actions/hospital.actions'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ViewMoreModel({ viewmore, closeviewmore, modelData }) {
  console.log(modelData)
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => closeviewmore();
  const handleValidationUserInfo = () => {
    let formIsValid = true;
    let newErrors = {};

    // name
    if (fieldsUser.name == "") {
      formIsValid = false;
      newErrors = { ...newErrors, name: 'Enter name' };
    }


    // title
    if (fieldsUser.title == "") {
      formIsValid = false;
      newErrors = { ...newErrors, title: 'Empty field' };
    }

    // mobNo
    if (fieldsUser.mobNo == '') {
      formIsValid = false;
      newErrors = { ...newErrors, mobNo: 'Empty field' };
    }


    // alternateNo
    if (fieldsUser.alternateNo == '') {
      formIsValid = false;
      newErrors = { ...newErrors, alternateNo: 'Empty field' };
    }
    //aboutUs
    if (fieldsUser.aboutUs == '') {
      formIsValid = false;
      newErrors = { ...newErrors, aboutUs: 'Empty field' };
    }

    //SpecializationId
    if (fieldsUser.SpecializationId == '') {
      formIsValid = false;
      newErrors = { ...newErrors, SpecializationId: 'Empty field' };
    }





    setErrors(newErrors);
    return formIsValid;
  };
  const [error, setErrors] = React.useState({});
  const dispatch = useDispatch()
  const selector = useSelector(state => state)

  React.useEffect(() => {
    setFieldsUser({
      title: modelData.title,
      name: modelData.name,
      mobNo: modelData.mobNo,
      aboutUs: modelData.aboutUs,
      alternateNo: modelData.alternateNo,
      specializationId: modelData?.specializationId?.name,
      profileImg: modelData?.profileImg,
      expireance: modelData?.expireance,
      position: modelData?.position,
      Degree: modelData?.Degree


    })

    console.log(modelData)
  }, [modelData])




  const [fieldsUser, setFieldsUser] = React.useState({});

  console.log(fieldsUser)
  return (
    <div>
      <Modal
        open={viewmore}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 lg:w-[700px] w-11/12 mx-auto bg-white rounded-lg shadow-xl p-4">

          <Box className='bg-[#005F60] rounded-xl flex justify-between items-center '>
            <Box className="px-3 py-2 text-white font-bold" >About Doctor</Box>
            <Box className="px-3 py-2 text-white font-bold"><CloseRoundedIcon onClick={handleClose} className=" cursor-pointer text-white font-bold" /></Box>
          </Box>

          <div className='grid xl:grid-cols-2 grid-cols-1 gap-4 py-6'>
            <div className='border shadow-md'>
              <div className='flex items-center gap-6 p-4 bg-gray-200'>
                <p className='text-lg font-bold'>Dr.Name</p>
                :
                <p className='text-md font-semibold'>{`${fieldsUser.title} ${fieldsUser.name}`}</p>
              </div>
              <div className='flex items-center gap-6 p-4 '>
                <p className='text-lg font-bold'>Contact Number</p>
                :
                <p className='text-md font-semibold'> {fieldsUser.mobNo || "--"}</p>
              </div>
              <div className='flex items-center gap-6 p-4 bg-gray-200'>
                <p className='text-lg font-bold'>Alternate Number</p>
                :
                <p className='text-md font-semibold'>{fieldsUser.alternateNo || "--"}</p>
              </div>
              <div className='flex items-center gap-6 p-4'>
                <p className='text-lg font-bold'>Experience</p>
                :
                <p className='text-md font-semibold'>  {fieldsUser.expireance || "--"}</p>
              </div>
            </div>
            <div className='border shadow-md'>
              <div className='flex items-center gap-6 p-4 bg-gray-200'>
                <p className='text-lg font-bold'>Position</p>
                :
                <p className='text-md font-semibold'> {fieldsUser.position || "--"}</p>
              </div>
              <div className='flex items-center gap-6 p-4 '>
                <p className='text-lg font-bold'>Degree</p>
                :
                <p className='text-md font-semibold'>{fieldsUser.Degree || "--"}</p>
              </div>
              <div className='flex items-center gap-6 p-4 bg-gray-200'>
                <p className='text-lg font-bold'>Specialization</p>
                :
                <p className='text-md font-semibold'> {fieldsUser?.specializationId || "--"}</p>
              </div>
              <div className='flex items-start gap-6 p-4'>
                <p className='text-lg font-bold'>About Us</p>
                :
                <p className='text-md font-semibold'>{fieldsUser.aboutUs || "--"}</p>
              </div>
            </div>


          </div>

          {/* <form className="grid lg:grid-cols-2 grid-cols-1 gap-4 h-[400px] overflow-y-auto py-4">


            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                Dr.Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Enter Mobile Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={`${fieldsUser.title} ${fieldsUser.name}`}

              />
              {error['name'] && <p className='text-sm text-red-500'>{error.name}</p>}
            </div>
            <div>
              <label htmlFor="mobNo" className="block text-sm font-medium text-gray-700">
                Dr.Mobile Number
              </label>
              <input
                id="mobNo"
                name="mobNo"
                type="text"
                placeholder="Enter Contact Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.mobNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.mobNo || "--"}

              />
              {error['mobNo'] && <p className='text-sm text-red-500'>{error.mobNo}</p>}
            </div>
            <div>
              <label htmlFor="alternateNo" className="block text-sm font-medium text-gray-700">
                Alternate Mobile Number
              </label>
              <input
                id="alternateNo"
                name="alternateNo"
                type="text"
                placeholder="Enter alternateNo"
                className={`mt-1 p-2 w-full rounded-md border ${error.alternateNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.alternateNo || "--"}

              />
              {error['alternateNo'] && <p className='text-sm text-red-500'>{error.alternateNo}</p>}
            </div>
            <div>
              <label htmlFor="mobNo" className="block text-sm font-medium text-gray-700">
                Experience
              </label>
              <input
                id="mobNo"
                name="mobNo"
                type="text"
                placeholder="Enter Contact Number"
                className={`mt-1 p-2 w-full rounded-md border ${error.mobNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.expireance || "--"}
              // onChange={handleChange}
              />
              {error['mobNo'] && <p className='text-sm text-red-500'>{error.mobNo}</p>}
            </div>
            <div>
              <label htmlFor="alternateNo" className="block text-sm font-medium text-gray-700">
                Position
              </label>
              <input
                id="alternateNo"
                name="alternateNo"
                type="text"
                placeholder="Enter alternateNo"
                className={`mt-1 p-2 w-full rounded-md border ${error.alternateNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.position || "--"}
              // onChange={handleChange}
              />
              {error['alternateNo'] && <p className='text-sm text-red-500'>{error.alternateNo}</p>}
            </div>
            <div>
              <label htmlFor="alternateNo" className="block text-sm font-medium text-gray-700">
                Degree
              </label>
              <input
                id="alternateNo"
                name="alternateNo"
                type="text"
                placeholder="Enter alternateNo"
                className={`mt-1 p-2 w-full rounded-md border ${error.alternateNo ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.Degree || "--"}
              // onChange={handleChange}
              />
              {error['alternateNo'] && <p className='text-sm text-red-500'>{error.alternateNo}</p>}
            </div>
            <div>
              <label htmlFor="specializationId" className="block text-sm font-medium text-gray-700">
                Specialization
              </label>
              <input
                id="specializationId"
                name="specializationId"
                className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
                // value={fieldsUser.specializationId || modelData && modelData.specializationId && modelData?.specializationId[0]?.id || ""}
                value={fieldsUser?.specializationId || "--"}

              />
              {error['specializationId'] && <p className='text-sm text-red-500'>{error.specializationId}</p>}
            </div>

            <div>
              <label htmlFor="aboutUs" className="block text-sm font-medium text-gray-700">
                About Us
              </label>
              <textarea
                id="aboutUs"
                name="aboutUs"
                type="text"
                placeholder="Enter About Us"
                className={`mt-1 p-2 w-full rounded-md border ${error.aboutUs ? 'border-red-500' : 'border-gray-300'
                  } focus:outline-none focus:border-blue-500`}
                value={fieldsUser.aboutUs || "--"}

              />
              {error['aboutUs'] && <p className='text-sm text-red-500'>{error.aboutUs}</p>}
            </div>

          </form> */}

        </div>
      </Modal>
    </div>

  );
}